// Passkey (WebAuthn) helpers — native browser-API, geen extra dependency.
// Backend: /api/auth/webauthn/{register-options,register,login-options,login} (@simplewebauthn/server v14, JSON met base64url-strings)
const b64uToBuf = (s) => { const b = atob(String(s).replace(/-/g, '+').replace(/_/g, '/').padEnd(Math.ceil(s.length / 4) * 4, '=')); const a = new Uint8Array(b.length); for (let i = 0; i < b.length; i++) a[i] = b.charCodeAt(i); return a.buffer; };
const bufToB64u = (buf) => btoa(String.fromCharCode(...new Uint8Array(buf))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

export function passkeyBeschikbaar() {
  return typeof window !== 'undefined' && !!window.PublicKeyCredential && !!navigator.credentials;
}

export async function passkeyRegistreren(api, deviceNaam) {
  const { data: opts } = await api.post('/auth/webauthn/register-options');
  const pk = { ...opts, challenge: b64uToBuf(opts.challenge), user: { ...opts.user, id: b64uToBuf(opts.user.id) },
    excludeCredentials: (opts.excludeCredentials || []).map(c => ({ ...c, id: b64uToBuf(c.id) })) };
  const cred = await navigator.credentials.create({ publicKey: pk });
  const body = {
    id: cred.id, rawId: bufToB64u(cred.rawId), type: cred.type, authenticatorAttachment: cred.authenticatorAttachment,
    clientExtensionResults: cred.getClientExtensionResults ? cred.getClientExtensionResults() : {},
    response: { clientDataJSON: bufToB64u(cred.response.clientDataJSON), attestationObject: bufToB64u(cred.response.attestationObject),
      transports: cred.response.getTransports ? cred.response.getTransports() : [] },
    deviceNaam: deviceNaam || (navigator.userAgent.includes('Android') ? 'Android-telefoon' : navigator.userAgent.includes('iPhone') ? 'iPhone' : 'Dit apparaat'),
  };
  const { data } = await api.post('/auth/webauthn/register', body);
  return data;
}

export async function passkeyLogin(api, gebruikersnaam) {
  const { data: opts } = await api.post('/auth/webauthn/login-options', gebruikersnaam ? { gebruikersnaam } : {});
  const pk = { ...opts, challenge: b64uToBuf(opts.challenge), allowCredentials: (opts.allowCredentials || []).map(c => ({ ...c, id: b64uToBuf(c.id) })) };
  const cred = await navigator.credentials.get({ publicKey: pk, mediation: 'optional' });
  const body = {
    id: cred.id, rawId: bufToB64u(cred.rawId), type: cred.type, authenticatorAttachment: cred.authenticatorAttachment,
    clientExtensionResults: cred.getClientExtensionResults ? cred.getClientExtensionResults() : {},
    response: { clientDataJSON: bufToB64u(cred.response.clientDataJSON), authenticatorData: bufToB64u(cred.response.authenticatorData),
      signature: bufToB64u(cred.response.signature), userHandle: cred.response.userHandle ? bufToB64u(cred.response.userHandle) : null },
    gebruikersnaam: gebruikersnaam || undefined,
  };
  const { data } = await api.post('/auth/webauthn/login', body);
  return data; // { success, token, gebruiker }
}
